/**
 * @file index.tsx
 * @module app/modules/orders-delivery/index
 * @description Orders delivery module component for UTrade Admin.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { lazy } from 'react';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
import AddNewOrderSubAdmin from './pages/operations/add-new-order-assist';
import "./styles/page.css";
import ReturnOrder from './pages/operations/return-order';
import AdjustReturnOrder from './pages/operations/adjust-return-order';
import ReviewOrderList from './pages/overview/review-orders-list';
import AdjustProductInventory from './pages/operations/adjust-product-inventory';
import DeliveryRoutesPlanDetails from './pages/planning/delivery-plan-details';
const OrderDetails = lazy(() => import('./pages/order-details/order-details'));
const PastDeliveryRouteDetails = lazy(
  () => import('./pages/planning/past-delivery-route-details')
);
const PastDeliveryRoutePlans = lazy(
  () => import('./pages/planning/past-delivery-route-plans')
);
const GoodsLoadingDetails = lazy(() => import('./pages/planning/goods-loading-details'));
const RouteDetails = lazy(() => import('./pages/planning/route-details'));
const EditOrderDetails = lazy(() => import('./pages/order-details/edit-order-details'));
const AllOrders = lazy(() => import('./pages/overview/all-orders'));
const AddNewOrder = lazy(() => import('./pages/overview/add-new-order'));

const ordersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Orders & Delivery',
    path: '/orders',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          index
          element={
            <>
              <PageTitle>
                Orders & Delivery
              </PageTitle>
              <AllOrders />
            </>
          }
        />
        <Route
          path="add-new-order"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Add New Order
              </PageTitle>
              <AddNewOrder />
            </>
          }
        />
        <Route
          path="adjust-return-order"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Adjust Return Order
              </PageTitle>
              <AdjustReturnOrder />
            </>
          }
        />
        <Route
          path="adjust-product-inventory"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Adjust Product Inventory
              </PageTitle>
              <AdjustProductInventory />
            </>
          }
        />
        <Route
          path="return-order"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Return Order
              </PageTitle>
              <ReturnOrder />
            </>
          }
        />
        <Route
          path="add-new-order-assistAdmin"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Add New Order
              </PageTitle>
              <AddNewOrderSubAdmin />
            </>
          }
        />
        <Route
          path="order-details"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Order Details
              </PageTitle>
              <OrderDetails />
            </>
          }
        />
        <Route
          path="edit-order-details"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Edit Order Details
              </PageTitle>
              <EditOrderDetails />
            </>
          }
        />
        <Route
          path="past-delivery-route-plans"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Past Delivery Route Plans
              </PageTitle>
              <PastDeliveryRoutePlans />
            </>
          }
        />
        <Route
          path="past-delivery-route-details"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Past Delivery Route Details
              </PageTitle>
              <PastDeliveryRouteDetails />
            </>
          }
        />
        <Route
          path="goods-loading-details"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Goods Loading Details
              </PageTitle>
              <GoodsLoadingDetails />
            </>
          }
        />
        <Route
          path="review-order-list"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Review Order List
              </PageTitle>
              <ReviewOrderList />
            </>
          }
        />
        <Route
          path="route-details"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Route Details
              </PageTitle>
              <RouteDetails />
            </>
          }
        />
        <Route
          path="plan-details"
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>
                Delivery Route Plan Details
              </PageTitle>
              <DeliveryRoutesPlanDetails />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default index;
